import React from "react";
import Turnstile, { useTurnstile } from "react-turnstile";

import { create } from "zustand";

export const useCfStore = create((set) => ({
  token: null,
  setCftToken: (token) => set(() => ({ token })),

  reset: () => null,
  setResetFunction: (reset) => set(() => ({ reset })),
}));

const CfTurnstile = () => {
  const { setCftToken, setResetFunction } = useCfStore();

  const turnstile = useTurnstile();

  return (
    <div className="turnstile-block">
      <Turnstile
        size={"compact"}
        autoResetOnExpire={true}
        sitekey={
          process.env.NODE_ENV === "production"
            ? "0x4AAAAAAB8YzYh-qqF4ClOO"
            : "1x00000000000000000000BB"
        }
        onVerify={(token) => {
          setCftToken(token);
          setResetFunction(turnstile.reset);
        }}
      />
    </div>
  );
};

export default CfTurnstile;
